import { createContext, useContext} from "react";
import {getConstantVersion} from "../util/util";

// const defaultVersion = 1;
// const defaultVersion = 2;
const defaultVersion = getConstantVersion();

// global json
const initValue = {
    version: defaultVersion,
}

const getInitValue = () => {
    return initValue
};


// VersionContext ---------------------------------------------------
const getVersion = () => {
    return initValue.version;
}
const setVersion = (paramVersion) => {
    initValue.version = paramVersion;
}
const VersionContext = createContext({getInitValue, getVersion, setVersion});
export const useVersionContext = () => useContext(VersionContext);

// another context section


/**
 * createContext 안에 값들과 provider.value 안에 값이 항상 동일해야
 * 자식 컴포넌트에서 createContext 안에 값 접근 가능
 */

// common provider
export const GlobalContextProvider = ({ children }) => {
    return (
        <>
            <VersionContext.Provider value={{getInitValue, getVersion, setVersion}}>
                {/*<AnotherContext.Provider value={{setter,getter}}>*/}
                   {children}
                {/*</AnotherContext.Provider>*/}
            </VersionContext.Provider>
        </>
    );
};
